import { Flex } from "../mantine-passthroughs/index.js";
import { Body1 } from "../typography/Body1.js";
import { isValidElement } from "react";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/components/progress-bar/StartEndLabels.tsx
const InnerLabel = ({ label }) => {
	if (!label) return /* @__PURE__ */ jsx("span", {});
	if (isValidElement(label)) return label;
	return /* @__PURE__ */ jsx(Body1, { children: label });
};
const StartEndLabels = ({ startLabel, endLabel }) => {
	if (!startLabel && !endLabel) return null;
	return /* @__PURE__ */ jsxs(Flex, {
		justify: "space-between",
		align: "flex-start",
		children: [/* @__PURE__ */ jsx(InnerLabel, { label: startLabel }), /* @__PURE__ */ jsx(InnerLabel, { label: endLabel })]
	});
};

//#endregion
export { StartEndLabels };